export const MONTH_KEY_OPTIONS = Object.freeze({
  1: 'January',
  2: 'February',
  3: 'March',
  4: 'April',
  5: 'May',
  6: 'June',
  7: 'July',
  8: 'August',
  9: 'September',
  10: 'October',
  11: 'November',
  12: 'December',
});

export const CURRENCY_OPTIONS = Object.freeze([
  {
    value: 'rsd',
    label: 'RSD',
  },
  {
    value: 'eur',
    label: 'EUR',
  },
  {
    value: 'usd',
    label: 'USD',
  },
  {
    value: 'gbp',
    label: 'GBP',
  },
  {
    value: 'rub',
    label: 'RUB',
  },
]);

export const MONTHS_OPTIONS = Object.freeze([
  { value: 1, key: 'january' },
  { value: 2, key: 'february' },
  { value: 3, key: 'march' },
  { value: 4, key: 'april' },
  { value: 5, key: 'may' },
  { value: 6, key: 'june' },
  { value: 7, key: 'july' },
  { value: 8, key: 'august' },
  { value: 9, key: 'september' },
  { value: 10, key: 'october' },
  { value: 11, key: 'november' },
  { value: 12, key: 'december' },
]);

export const REASON_OF_LEAVE = Object.freeze([
  { value: 'Rođenje deteta', label: 'childBirthSer', valueEng: 'Childbirth' },
  { value: 'Svadba', label: 'weddingSer', valueEng: 'Wedding' },
  { value: 'Sahrana člana uže porodice', label: 'funeralSer', valueEng: 'Funeral of an immediate family member' },
  { value: 'Bolest člana uže porodice', label: 'illnessSer', valueEng: 'Illness of an immediate family member' },
  { value: 'Davanje krvi', label: 'bloodDonationSer', valueEng: 'Blood donation' },
  { value: 'Verski praznik', label: 'religiousHolidaySer', valueEng: 'Religious holiday' },
  { value: 'Privatni razlozi', label: 'personalSer', valueEng: 'Personal' },
  { value: 'Rođendan', label: 'birthdaySer', valueEng: 'Birthday' },
  { value: 'Ostalo', label: 'otherSer', valueEng: 'Other' },
]);

export const YEARS_OPTIONS = Array.from(
  { length: new Date().getFullYear() - 2020 + 11 },
  (_, i) => {
    return { value: 2020 + i, label: 2020 + i };
  }
);

export const CONFIRM_OPTIONS = Object.freeze([
  { label: 'yes', value: 'true' },
  { label: 'no', value: 'false' },
]);
